import React from 'react';
import * as Yup from 'yup';
import moment from 'moment';
import { shift } from '@floating-ui/dom';
import { DateInput } from 'components/layout/form-fields/inputs/DateInput';
import { FormField } from 'components/layout/modals/components';
import { jobApplicationStore } from './JobApplicationStore';

const DATE_ONLY_FORMAT = 'YYYY-MM-DD';

export const occurredOnSchema = Yup.date()
	.nullable()
	.label('Date')
	.when('type', {
		is: type => jobApplicationStore.isMilestoneTaskType(type?.value),
		then: schema => schema.required()
	});

export const toOccurredOnValue = date =>
	date ? moment(date).format(DATE_ONLY_FORMAT) : null;

export const parseOccurredOn = occurredOn =>
	occurredOn ? moment(occurredOn, DATE_ONLY_FORMAT).toDate() : null;

export const formatOccurredOn = occurredOn =>
	occurredOn ? moment(occurredOn, DATE_ONLY_FORMAT).format('ll') : 'N/A';

export function JobApplicationTaskOccurredOnField({ formikBag }) {
	const type = formikBag.values.type?.value;
	if (!jobApplicationStore.isMilestoneTaskType(type)) {
		return null;
	}

	return (
		<FormField
			label={jobApplicationStore.getOccurredOnLabel(type)}
			required
			error={formikBag.errors.occurredOn}>
			<DateInput
				value={formikBag.values.occurredOn}
				maxDate={type === 'placement' ? undefined : new Date()}
				popperPlacement="top-start"
				popperModifiers={[
					shift({
						padding: 5,
						crossAxis: true
					})
				]}
				onBlur={() => formikBag.setFieldTouched('occurredOn')}
				onChange={newDate => {
					formikBag.setFieldValue('occurredOn', newDate);
				}}
			/>
		</FormField>
	);
}
